import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SettingsService } from "./settings.service";
import { Helpers } from "src/app/services/app.helpers";
import { ToastService } from "src/app/core/toast.service";
import * as moment from "moment";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"]
})
export class SettingsComponent implements OnInit {
  @Output() saved = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();

  form: FormGroup;
  profileForm: FormGroup;
  isFormSubmiting = false;
  activePage = 1;
  yearRange = "1930:" + moment().format("YYYYY");

  constructor(
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private toastService: ToastService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.createForm();
    this.createProfileForm();
    this.getData();
    this.getProfile();
  }

  createForm() {
    this.form = this.fb.group({
      allowUknownToSeePosts: [true],
      allowUknownToSeeFriends: [true],
      allowUknownToSeeFollowers: [true],
      allowFriendsToSeeFriends: [true],
      allowFriendsToSeeFollowers: [true],
      allowFollowersToSeeFriends: [true],
      allowFollowersToSeeFollowers: [true]
    });
  }

  createProfileForm() {
    this.profileForm = this.fb.group({
      firstname: ["", Validators.required],
      lastname: ["", Validators.required],
      dateOfBirth: [""],
      city: [""]
    });
  }

  getData() {
    this.settingsService.getSettings().subscribe(response => {
      this.form.patchValue(response);
    });
  }

  getProfile() {
    this.settingsService.getProfile().subscribe(response => {
      if (response.dateOfBirth) response.dateOfBirth = new Date(response.dateOfBirth);
      this.profileForm.patchValue(response);
    });
  }

  update() {
    Helpers.markFormGroupDirty(this.form);
    Helpers.markFormGroupTouched(this.form);

    if (!this.form.valid) {
      this.toastService.errorMessage("alerts.INVALID_FORM_CORRECT_THEM");
      return;
    }

    const model = this.form.getRawValue();

    this.isFormSubmiting = true;
    this.settingsService.updateSettings(model).subscribe(() => {
      this.isFormSubmiting = false;
      this.saved.emit();
      this.toastService.successMessage("settingsPage.UpdateSuccess");
    }, err => {
      this.isFormSubmiting = false;
      this.toastService.generalErrorMessage();
    });
  }

  updateProfile() {
    Helpers.markFormGroupDirty(this.profileForm);
    Helpers.markFormGroupTouched(this.profileForm);

    if (!this.profileForm.valid) {
      this.toastService.errorMessage("alerts.INVALID_FORM_CORRECT_THEM");
      return;
    }

    const model = this.profileForm.getRawValue();

    this.isFormSubmiting = true;
    this.settingsService.updateProfile(model).subscribe(() => {
      this.isFormSubmiting = false;
      this.saved.emit();
      this.toastService.successMessage("settingsPage.UpdateProfileSuccess");
      this.authService.getUserProfile().subscribe(res => {
        this.authService.saveLocalProfile(res);
      });
    }, err => {
      this.isFormSubmiting = false;
      this.toastService.generalErrorMessage();
    });
  }

  close() {
    this.closed.emit();
  }
}
